import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
var NewStockMovement = function () { return (_jsx(Navigate, { to: "/stock_movements", replace: true, state: { openNewStockMovement: true } })); };
export default NewStockMovement;
